import { render, staticRenderFns } from "./SalaryCaculator.vue?vue&type=template&id=cfcd3ffe&scoped=true"
import script from "./SalaryCaculator.vue?vue&type=script&lang=js"
export * from "./SalaryCaculator.vue?vue&type=script&lang=js"
import style0 from "./SalaryCaculator.vue?vue&type=style&index=0&id=cfcd3ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcd3ffe",
  null
  
)

export default component.exports